import { WindowType } from "../../util";
import { AccountSelect, Board, BoardSharedUserInfo, Card, CardSharedUserInfo } from '../backend/backendapi';
import { KanbanState } from "./kanban.model";

declare var window: WindowType;

export function isOwn(board: Board): boolean {
    return board.userId === window.application.kanban.user?.id;
}

export function isPrivate(state: KanbanState, board: Board): boolean {
    return isOwn(board) && getSharedInfoBoard(state, board).userIds.length === 0;
}

export function getSharedInfoBoard(state: KanbanState, board: Board): BoardSharedUserInfo {
    let info = state.shareBoardInfos.find(e => e.boardId === board.id);
    if (!info) {
        info = new BoardSharedUserInfo({ boardId: board.id!, userIds: [] });
        state.shareBoardInfos.push(info);
    }

    return info;
}

export function getSharedInfoCard(state: KanbanState, card: Card): CardSharedUserInfo {
    let info = state.shareCardInfos.find(e => e.cardId === card.id);
    if (!info) {
        info = new CardSharedUserInfo({ cardId: card.id!, accountIds: [] });
        state.shareCardInfos.push(info);
    }

    return info;
}

export function getAccountName(state: KanbanState, accountId: number) {
    const acc = state.accounts?.parentList?.find(e => e.dbId === accountId);
    return acc ? acc.text : '';
}

export function isBoardNotInSelectedAccount(board: Board, accounts: AccountSelect | null): boolean {
    return board.fkAccountId !== accounts?.selectedItem;
}
